"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.similarHotelsReducer = exports.initialStateOfSimilarHotels = void 0;
var _reduxActions = require("redux-actions");
var _ramda = require("ramda");
var _actions = require("./actions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialStateOfSimilarHotels = exports.initialStateOfSimilarHotels = {
  similarHotels: [],
  selectedHotels: {}
};
var similarHotelsReducer = exports.similarHotelsReducer = (0, _reduxActions.handleActions)(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _actions.setSimilarHotels, function (state, _ref) {
  var hotels = _ref.payload;
  return (0, _ramda.assoc)('similarHotels', hotels, state);
}), _actions.setActiveHotelById, function (state, _ref2) {
  var hotelID = _ref2.payload;
  return (0, _ramda.assocPath)(['selectedHotels', hotelID], true, state);
}), _actions.detachActiveHotelById, function (state, _ref3) {
  var hotelID = _ref3.payload;
  return (0, _ramda.dissocPath)(['selectedHotels', hotelID], state);
}), _actions.resetStore, function () {
  return (0, _ramda.clone)(initialStateOfSimilarHotels);
}), initialStateOfSimilarHotels);